import { useState } from "react";

// MU
import { Grid } from "@material-ui/core";

// Styles
import { paletas } from "../../../../styles/theme";
import { Wrapper } from "./styles";

// Componentes
import Botao from "../../../../componentes/botao";
import Divisor from "../../../../componentes/divisor";
import Loading from "../../../../componentes/loading";

// Context
import { useApp } from "../../../../contexts/app";
import { GiTwoCoins } from "react-icons/gi";

type Props = {
  fecharModo: () => void;
};

export default function Treino({ fecharModo }: Props) {
  const { usuario, setUsuarioCorrente } = useApp();
  const [habilitarBusca, setHabilitarBusca] = useState(false);
  let updateUsuario = usuario;

  const iniciarTorneio = () => {
    if (usuario) {
      updateUsuario.system.in_combat = true;
      setUsuarioCorrente(updateUsuario);
      setHabilitarBusca(true);
    }
  };

  const finalizarTorneio = () => {
    updateUsuario.system.in_combat = false;
    setUsuarioCorrente(updateUsuario);
    setHabilitarBusca(false);
  };

  return (
    <Wrapper>
      {habilitarBusca ? (
        <>
          <Grid
            container
            item
            alignContent="center"
            alignItems="center"
            justify="center"
            className="content"
          >
            <Loading loading={true} cor={paletas.DarkOrange}>
              {null}
            </Loading>
          </Grid>
          <Grid container justify="flex-end">
            <Grid item xs={5} sm={2}>
              <Botao
                type="button"
                value="DESISTIR"
                background={paletas.RedTheme}
                border={paletas.RedTheme}
                color={paletas.White}
                size="16px"
                disabled={false}
                onClick={finalizarTorneio}
              />
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={12} className="headerInterno">
            <h3>
              Torneio
              <Divisor color={paletas.DarkOrange} />
            </h3>
            <Grid container spacing={2} className="tabelaTorneio">
              <Grid item xs={12} sm={4}>
                <h4>LIGA BRONZE</h4>
                <h5>
                  Inscrição: <GiTwoCoins />
                  100 <span>DevCoins</span>
                </h5>
                <p>
                  <b>1° Lugar</b>: Prêmio: <GiTwoCoins />
                  1.000 <span>DevCoins</span>
                </p>
                <p>
                  <b>2° Lugar</b>: Prêmio: <GiTwoCoins />
                  600 <span>DevCoins</span>
                </p>
                <p>
                  <b>3° Lugar</b>: Prêmio: <GiTwoCoins />
                  300 <span>DevCoins</span>
                </p>
                <p>
                  <b>4° à 8° Lugar</b>: Prêmio: <GiTwoCoins />
                  150 <span>DevCoins</span>
                </p>
                <Grid item xs={12} className="botaoIniciar">
                  <Botao
                    type="button"
                    value="PARTICIPAR"
                    size="22px"
                    color={paletas.Grafite75}
                    background={paletas.DarkOrange}
                    border={paletas.DarkOrange}
                    disabled={
                      !(
                        usuario?.player_statistics?.league === "Bronze" ||
                        usuario?.player_statistics?.league === "Prata" ||
                        usuario?.player_statistics?.league === "Ouro"
                      )
                    }
                    onClick={iniciarTorneio}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} sm={4}>
                <h4>LIGA PRATA</h4>
                <h5>
                  Inscrição: <GiTwoCoins />
                  200 <span>DevCoins</span>
                </h5>
                <p>
                  <b>1° Lugar</b>: Prêmio: <GiTwoCoins />
                  2.000 <span>DevCoins</span>
                </p>
                <p>
                  <b>2° Lugar</b>: Prêmio: <GiTwoCoins />
                  1.200 <span>DevCoins</span>
                </p>
                <p>
                  <b>3° Lugar</b>: Prêmio: <GiTwoCoins />
                  600 <span>DevCoins</span>
                </p>
                <p>
                  <b>4° à 8° Lugar</b>: Prêmio: <GiTwoCoins />
                  300 <span>DevCoins</span>
                </p>
                <Grid item xs={12} className="botaoIniciar">
                  <Botao
                    type="button"
                    value="PARTICIPAR"
                    size="22px"
                    color={paletas.Grafite75}
                    background={paletas.DarkOrange}
                    border={paletas.DarkOrange}
                    disabled={
                      !(
                        usuario?.player_statistics?.league === "Prata" ||
                        usuario?.player_statistics?.league === "Ouro"
                      )
                    }
                    onClick={iniciarTorneio}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} sm={4}>
                <h4>LIGA OURO</h4>
                <h5>
                  Inscrição: <GiTwoCoins />
                  400 <span>DevCoins</span>
                </h5>
                <p>
                  <b>1° Lugar</b>: Prêmio: <GiTwoCoins />
                  4.000 <span>DevCoins</span>
                </p>
                <p>
                  <b>2° Lugar</b>: Prêmio: <GiTwoCoins />
                  2.400 <span>DevCoins</span>
                </p>
                <p>
                  <b>3° Lugar</b>: Prêmio: <GiTwoCoins />
                  1.200 <span>DevCoins</span>
                </p>
                <p>
                  <b>4° à 8° Lugar</b>: Prêmio: <GiTwoCoins />
                  600 <span>DevCoins</span>
                </p>
                <Grid item xs={12} className="botaoIniciar">
                  <Botao
                    type="button"
                    value="PARTICIPAR"
                    size="22px"
                    color={paletas.Grafite75}
                    background={paletas.DarkOrange}
                    border={paletas.DarkOrange}
                    disabled={!(usuario?.player_statistics?.league === "Ouro")}
                    onClick={iniciarTorneio}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container justify="flex-end">
            <Grid item xs={5} sm={2}>
              <Botao
                type="button"
                value="VOLTAR"
                background={paletas.RedTheme}
                border={paletas.RedTheme}
                color={paletas.White}
                size="16px"
                disabled={false}
                onClick={fecharModo}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Wrapper>
  );
}
